import React, {useState, useRef} from 'react'
import PropTypes from 'prop-types'
import {Box, useBreakpointValue, useMultiStyleConfig} from '@chakra-ui/react'
import YoutubeIframe from '../../youtube-video'
import {getDamImageUrl} from '../../../utils/contentstack-utils'
import {PlayIcon} from '../../icons'
import {useIntl, defineMessages} from 'react-intl'

const messages = defineMessages({
    playVideo: {
        id: 'editorial_video.button.play_video',
        defaultMessage: 'Play video',
    },
    pauseVideo: {
        id: 'editorial_video.button.pause_video',
        defaultMessage: 'Pause video',
    },
})

export const EditorialVideo = ({data}) => {
    const [isPlaying, setIsPlaying] = useState(false)
    const videoRef = useRef(null)
    const {formatMessage} = useIntl()

    const styles = useMultiStyleConfig('Video')

    const handlePlayPause = () => {
        if (videoRef.current) {
            if (videoRef.current.paused) {
                videoRef.current.play()
                setIsPlaying(true)
            } else {
                videoRef.current.pause()
                setIsPlaying(false)
            }
        }
    }

    const handleVideoEnd = () => {
        setIsPlaying(false)
    }

    const videoThumbnail = useBreakpointValue({
        base: getDamImageUrl(data?.mobile_fallback_thumbnaill),
        sm: getDamImageUrl(data?.desktop_fallback_thumbnail),
    })

    if (data?.type_of_video === 'Akamai reference') {
        return (
            <Box {...styles.videoContainer}>
                <Box
                    as="video"
                    ref={videoRef}
                    onEnded={handleVideoEnd}
                    onPlay={() => setIsPlaying(true)}
                    onPause={() => setIsPlaying(false)}
                    muted
                    aria-hidden="true"
                    {...styles.video}
                >
                    <source
                        src={data?.akamai_videos?.desktop}
                        type="video/mp4"
                        media="(min-width: 1024px)"
                    />
                    <source
                        src={data?.akamai_videos?.mobile || data?.akamai_videos?.desktop}
                        type="video/mp4"
                        media="(max-width: 1023px)"
                    />
                    Your browser does not support the video tag.
                </Box>

                <Box
                    as="button"
                    onClick={handlePlayPause}
                    aria-label={formatMessage(isPlaying ? messages.pauseVideo : messages.playVideo)}
                    {...styles.playIconContainer}
                >
                    {!isPlaying && <PlayIcon {...styles.playIcon} data-testid="play-icon" />}
                </Box>
            </Box>
        )
    }

    if (data?.type_of_video === 'Youtube link') {
        return (
            <Box {...styles.videoContainerYoutube} data-testid="youtube-video">
                <YoutubeIframe
                    title={data?.title}
                    videoSrc={data?.youtube_link}
                    thumbnail={videoThumbnail}
                />
            </Box>
        )
    }
}

EditorialVideo.propTypes = {
    data: PropTypes.object,
}
